var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconScheduled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E8E9EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 16.8182H18.8V19.1255L20.752 20.2791L20.152 21.3427L17.6 19.8373V16.8182ZM20.8 12.7273H9.6V21.7273H13.336C12.992 20.9827 12.8 20.1482 12.8 19.2727C12.8 17.7538 13.39 16.297 14.4402 15.2229C15.4904 14.1489 16.9148 13.5455 18.4 13.5455C19.256 13.5455 20.072 13.7418 20.8 14.0936V12.7273ZM9.6 23.3636C9.17565 23.3636 8.76869 23.1912 8.46863 22.8844C8.16857 22.5775 8 22.1613 8 21.7273V10.2727C8 9.36455 8.712 8.63636 9.6 8.63636H10.4V7H12V8.63636H18.4V7H20V8.63636H20.8C21.2243 8.63636 21.6313 8.80877 21.9314 9.11564C22.2314 9.42252 22.4 9.83874 22.4 10.2727V15.2636C23.392 16.2945 24 17.71 24 19.2727C24 20.7917 23.41 22.2484 22.3598 23.3225C21.3096 24.3966 19.8852 25 18.4 25C16.872 25 15.488 24.3782 14.48 23.3636H9.6ZM18.4 15.3045C17.371 15.3045 16.3841 15.7226 15.6564 16.4668C14.9288 17.211 14.52 18.2203 14.52 19.2727C14.52 21.4655 16.256 23.2409 18.4 23.2409C18.9095 23.2409 19.4141 23.1383 19.8848 22.9388C20.3556 22.7394 20.7833 22.4471 21.1436 22.0787C21.5039 21.7102 21.7897 21.2727 21.9847 20.7913C22.1796 20.3098 22.28 19.7938 22.28 19.2727C22.28 17.08 20.544 15.3045 18.4 15.3045Z",
    fill: "#A8ACAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScheduled);
export default __webpack_public_path__ + "static/media/icon-scheduled.e4a732574cd994d0b4883ee378750d20.svg";
export { ForwardRef as ReactComponent };